// extracted by mini-css-extract-plugin
module.exports = {"noAnswers":"NoAnswers-module--noAnswers--4b1d88"};